/**
 * Method: initScrollHeader
 *
 * Scroll header (when on left) together with main part
 *
 * @return void
 */
export function initScrollHeader() {
  let header = document.getElementsByTagName('header')[0];
  document.addEventListener('scroll', function (event) {});
  let lastKnownScrollPosition = 0;
  let ticking = false;

  function scrollHeader(scrollPos) {
    let toScrollHeader = true;
    document.querySelectorAll(':hover').forEach(function (el) {
      if (el.tagName == 'HEADER') {
        toScrollHeader = false;
      }
    });
    if (toScrollHeader) {
      header.scrollTop = scrollPos;
    }
  }

  document.addEventListener('scroll', function (e) {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        scrollHeader(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });
}
